export enum SortingManagerMode {
    CASCADE = 'cascade',
    MANUAL  = 'manual',
    CUSTOM  = 'custom'
}